import { render, staticRenderFns } from "./DashboardDeliveryConsultList.vue?vue&type=template&id=6ae6c5ee&"
import script from "./DashboardDeliveryConsultList.vue?vue&type=script&lang=ts&"
export * from "./DashboardDeliveryConsultList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports